import { Integration, SDK } from '@commercetools/frontend-sdk';
import { AccountActions, getAccountActions } from './actions/AccountActions';
import { getCartActions, CartActions } from './actions/CartActions';
import { ContenstackActions, getContenstackActions } from './actions/ContentstackActions';
import { CustomObjectActions, getCustomObjectActions } from './actions/CustomObjectActions';
import { getProductActions, ProductActions } from './actions/ProductActions';
import { getProjectActions, ProjectActions } from './actions/ProjectActions';
import { ComposableCommerceEvents } from '../types/events/ComposableCommerceEvents';

class ComposableCommerce extends Integration<ComposableCommerceEvents> {
  constructor(sdk: SDK<ComposableCommerceEvents>) {
    super(sdk);

    this.project = getProjectActions(sdk);
    this.product = getProductActions(sdk);
    this.cart = getCartActions(sdk);
    this.account = getAccountActions(sdk);
    this.contentstack = getContenstackActions(sdk);
    this.customObjects = getCustomObjectActions(sdk);
  }

  unregisterExtension(): void {}

  project: ProjectActions;
  product: ProductActions;
  cart: CartActions;
  account: AccountActions;
  contentstack: ContenstackActions;
  customObjects: CustomObjectActions;
}

export { ComposableCommerce };
